



































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import Button from '@/app/ui/components/Button/index.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import { validationMixin } from 'vuelidate'
import { Validations } from 'vuelidate-property-decorators'
import {
  required,
  minLength,
  sameAs,
  maxLength,
  helpers,
} from 'vuelidate/lib/validators'
import controller from '@/app/ui/controllers/AuthController'
import IconCheckCircle from '@/app/ui/assets/ics_f_check_circle.vue'
import CloseCircle from '@/app/ui/assets/x-circle.vue'
import { Utils } from '@/app/infrastructures/misc'
import IconWarningTriangle from '@/app/ui/assets/icon_warning_triangles.vue'

// Custom validator for uppercase letters
const containsUppercase = helpers.regex('containsUppercase', /[A-Z]/);

// Custom validator for numbers
const containsNumber = helpers.regex('containsNumber', /[0-9]/);

// Custom validator for symbols
const containsSymbol = helpers.regex('containsSymbol', /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/);

@Component({
  mixins: [validationMixin],
  components: {
    Button,
    Modal,
    TextInput,
    LoadingOverlay,
    IconCheckCircle,
    CloseCircle,
    IconWarningTriangle
  },
})
export default class ResetPasswordModal extends Vue {
  @Prop({ type: String, required: true }) token!: string
  @Prop({ type: Boolean, default: false}) isFromOTP!: boolean

  form = {
    password: '',
    passwordConfirmation: '',
  }

  created(): void {
    if (this.isFromOTP) return;
    controller.forgotPasswordVerify(this.token)
  }

  @Validations()
  validations(): Record<string, any> {
    return {
      form: {
        password: {
          required,
          maxLength: maxLength(72),
          minLength: minLength(8),
          containsUppercase,
          containsNumber,
          containsSymbol
        },
        passwordConfirmation: {
          sameAs: sameAs(() => this.form.password),
        },
      },
    }
  }

  private sendResetPassword() {
    this.$emit(
      'resetPassword',
      this.form.password,
      this.form.passwordConfirmation
    )
  }

  get isLoading(): boolean {
    return controller.isLoadingForgotPassword || controller.isLoading
  }

  private revalidatePasswordConfirm() {
    if (this.$v?.form.passwordConfirmation?.$dirty) {
      this.$v?.form.passwordConfirmation?.$touch()
    }
  }

  get containsEightCharacters() {
    return this.form.password.length >= 8;
  }

  get containsUppercase() {
    return /[A-Z]/.test(this.form.password);
  }

  get containsNumber() {
    return /[0-9]/.test(this.form.password);
  }

  get containsSymbol() {
    return /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(this.form.password);
  }
  
  cleanPhoneNumber(phoneNumber: string) {
    return Utils.cleanPhoneNumber(phoneNumber);
  }
}
